import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./store";
import { useLocation, type Location } from "react-router-dom";
import axios from "axios";
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = () =>
    useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppLocation = <S = unknown,>(): Location<S> =>
    useLocation() as Location<S>;

export const useAppAxios = axios.create({
    baseURL: import.meta.env.VITE_ADMIN_URL as string,
    headers: {
        "content-type": "application/json",
    },
    responseType: "json",
});
